export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-21T15:48:17",
  lastPipeline: "6589",
  version: "0.0.0",
  sentryDsn: '',
};
